/**
 * Logout affordance for the standalone setup-wizard screens.
 *
 * The setup wizard (`/setup`) renders full-screen with no app chrome, so a user
 * part-way through has no way to sign out and switch accounts. This drops a small
 * "Logout" control into the header row those screens already use for the
 * LanguageSelector.
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogOut, Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { useAuth } from '../../../shared/auth';

export function WizardLogoutButton() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      navigate('/login', { replace: true });
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      className="gap-1.5 text-muted-foreground"
      onClick={handleLogout}
      disabled={isLoggingOut}
      data-testid="wizard-logout-button"
    >
      {isLoggingOut ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <LogOut className="h-4 w-4" />
      )}
      {t('userMenu.logout')}
    </Button>
  );
}
